export enum TemperatureExcursionLocation {
  PORT_OF_DEPARTURE = 'Port of Departure',
  DURING_GROUND_TRANSPORTATION = 'During Ground Transportation',
  DURING_OCEAN_TRANSPORTATION = 'During Ocean Transportation',
  PORT_OF_ARRIVAL = 'Port of Arrival',
  LOCAL_WAREHOUSE = 'Local Warehouse',
  CUSTOMER_SITE = 'Customer Site',
}
